import React from 'react';
import PropTypes from 'prop-types';

import HeatmapGradient from './HeatmapGradient';
import HeatmapSettings from './HeatmapSettings';
import IncludeMidpoint from './IncludeMidpoint';
import WeightIntensity from './WeightIntensity';
import HeatmapContrast from './HeatmapContrast';
import HeatmapVisibility from './HeatmapVisibility';

import { SpaceWrapper } from '../styles';

const HeatmapOptions = ({
  gradient,
  showMidpoint,
  changeGradient,
  toggleMidpoint,
  heatmapWeightField,
  heatmapContrast,
  heatmapVisibility,
  aggregatableFields,
  changeWeightIntensity,
  changeContrast,
  changeVisibility,
  showWeightIntensity = true,
  showContrast = true,
  showVisibility = true,
}) => (
  <>
    <SpaceWrapper bottom={15}>
      <HeatmapGradient showMidpoint={showMidpoint} gradient={gradient} />
    </SpaceWrapper>
    <SpaceWrapper bottom={15}>
      <HeatmapSettings
        gradient={gradient}
        showMidpoint={showMidpoint}
        changeGradient={changeGradient}
      />
    </SpaceWrapper>
    <SpaceWrapper bottom={15}>
      <IncludeMidpoint gradient={gradient} toggleMidpoint={toggleMidpoint} />
    </SpaceWrapper>
    {showWeightIntensity && (
      <SpaceWrapper bottom={15}>
        <WeightIntensity
          heatmapWeightField={heatmapWeightField}
          aggregatableFields={aggregatableFields}
          onChangeWeightIntensity={changeWeightIntensity}
        />
      </SpaceWrapper>
    )}
    {showContrast && (
      <SpaceWrapper bottom={15}>
        <HeatmapContrast heatmapContrast={heatmapContrast} onChangeContrast={changeContrast} />
      </SpaceWrapper>
    )}
    {showVisibility && (
      <SpaceWrapper bottom={15}>
        <HeatmapVisibility
          heatmapVisibility={heatmapVisibility}
          onChangeVisibility={changeVisibility}
        />
      </SpaceWrapper>
    )}
  </>
);

HeatmapOptions.propTypes = {
  gradient: PropTypes.shape({
    lowestValue: PropTypes.string,
    midpointValue: PropTypes.string,
    highestValue: PropTypes.string,
  }).isRequired,
  showMidpoint: PropTypes.bool.isRequired,
  changeGradient: PropTypes.func.isRequired,
  toggleMidpoint: PropTypes.func.isRequired,
  heatmapWeightField: PropTypes.string,
  heatmapContrast: PropTypes.number,
  heatmapVisibility: PropTypes.number,
  aggregatableFields: PropTypes.array.isRequired,
  changeWeightIntensity: PropTypes.func.isRequired,
  changeContrast: PropTypes.func.isRequired,
  changeVisibility: PropTypes.func.isRequired,
  showWeightIntensity: PropTypes.bool,
  showContrast: PropTypes.bool,
  showVisibility: PropTypes.bool,
};

export default HeatmapOptions;
